import React from 'react';
import {
    Tag,
    Row,
    Space,
    Button,
    Input,
    DatePicker,
    Select,
    Table,
    Pagination,
    Checkbox,
    Modal,
    Transfer,
    message,
    Divider,
    Rate,
    Popover, Popconfirm
} from 'antd';
import {Redirect, Link, withRouter} from 'react-router-dom';
import store from "../store/store.js";
import {CloseOutlined} from '@ant-design/icons'
import {
    StarOutlined,
    PlusCircleOutlined,
    FormOutlined,
    MobileOutlined,
    PhoneOutlined,
    WechatOutlined,
    MailOutlined,
    HomeOutlined,
    GlobalOutlined,
    FolderOpenOutlined,
    UserOutlined,
    HistoryOutlined,
    SearchOutlined,
    QrcodeOutlined
} from '@ant-design/icons'
import moment from 'moment';

const {Search} = Input;
const {Option} = Select;
const {RangePicker} = DatePicker;

class DwView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            condition: {},
            visible: false,
        };
        this.mingpian = React.createRef();
        this.genjin = React.createRef();
        store.subscribe(() => {
            // console.log('state状态改变了，新状态如下')
            // console.log(store.getState().data.isLogin)
        })
    }

    componentDidMount() {


    }

    mdchange() {
        let that = this
        let visible = !that.state.visible
        that.setState({
            visible
        })
        if (visible) {
            that.getdata()
        } else {
            that.setState({
                condition: {},
            })
        }
    }

    getdata() {
        let that = this
        let arr = {}
        arr.id = that.props.id
        fetch('/Buy/detail', {
            method: "POST",
            body: JSON.stringify(arr)
        })
            .then(res => res.json())
            .then(data => {
                that.setState({
                    condition: data.data
                })
            })
    }

    arrfjlist(arr) {
        if (arr) {
            return arr.map((item, index) =>
                <div key={index}>
                    <a href={item.url} download={item.name}>
                        {item.name}
                    </a>
                </div>
            )
        }
    }

    dakuan(id) {
        let that = this
        fetch('/Buy/complete', {
            method: "POST", body: JSON.stringify({
                id
            })
        })
            .then(res => res.json())
            .then(data => {
                if(data.status==1){
                    message.success(data.msg)
                    that.getdata()
                }else{
                    message.error(data.msg)
                }
            })
    }

    render() {
        const columns = [
            {
                title: '时间',
                dataIndex: 'dateline',
                key: 'dateline',
                width: 120,
            }, {
                title: '金额',
                dataIndex: 'num',
                key: 'num',
                width: 120,
            }, {
                title: '备注',
                dataIndex: 'remark',
                key: 'remark',
            }, {
                title: '操作',
                dataIndex: 'cz',
                key: 'cz',
                align: 'center',
                fixed: 'right',
                width: 100,
                render: (row, record) => {
                    return (<>
                        <Space>
                            {record.status == 1 ? <Button type={"primary"} disabled>已打款</Button> : null}
                            {record.status == 0 ?
                                <Popconfirm
                                    title="确认打款?"
                                    onConfirm={() => this.dakuan(record.id)}
                                    okText="确认"
                                    cancelText="取消"
                                >
                                    <Button type={"primary"}>确认打款</Button>
                                </Popconfirm>
                                : null}
                        </Space>
                    </>)
                },
            },]
        return (
            <>
                {this.props.title ?
                    <a href='javascript:void(0)' type="link" onClick={this.mdchange.bind(this)}>{this.props.title}</a> :
                    <a href='javascript:void(0)' type="link" onClick={this.mdchange.bind(this)}>查看</a>}

                <Modal title="查看详情" destroyOnClose={true} bodyStyle={{padding: 15}} width={800}
                       visible={this.state.visible} onCancel={this.mdchange.bind(this)} footer={null}>
                    <div className={'view_box'}>
                        <div className={'view_title'}>合同信息</div>
                        <div className={'view_info'}>
                            <div className={'item'}>
                                <div className={'p1'}>项目名称</div>
                                <div className={'p2'}>{this.state.condition.name}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>采购项目类型</div>
                                <div className={'p2'}>{this.state.condition.cglx}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>采购方式</div>
                                <div className={'p2'}>{this.state.condition.cgfs}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>中标单位</div>
                                <div className={'p2'}>{this.state.condition.company}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>合同编号</div>
                                <div className={'p2'}>{this.state.condition.ref}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>合同金额</div>
                                <div className={'p2'}>{this.state.condition.amount}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>合同签订时间</div>
                                <div className={'p2'}>{this.state.condition.qdtime}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>服务期限</div>
                                <div className={'p2'}>{this.state.condition.time1} ~ {this.state.condition.time2}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>付款方式</div>
                                <div className={'p2'}>{this.state.condition.fkfs}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>对方联系人</div>
                                <div className={'p2'}>{this.state.condition.df_lxr}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>联系人电话</div>
                                <div className={'p2'}>{this.state.condition.df_phone}</div>
                            </div>
                            <div className={'item'}>
                                <div className={'p1'}>我方对接人</div>
                                <div className={'p2'}>{this.state.condition.wf_djr}</div>
                            </div>
                            <div className={'item all'}>
                                <div className={'p1'}>企业附件</div>
                                <div className={'p2'}>
                                    <Space wrap direction={"vertical"}>
                                        {this.arrfjlist(this.state.condition.fjlist)}
                                    </Space>
                                </div>
                            </div>
                        </div>
                        <div className={'view_title'}>支付计划</div>
                        <Table
                            bordered
                            columns={columns}
                            dataSource={this.state.condition.plan}
                            pagination={false}
                            style={{width: '100%'}}
                        />
                    </div>
                </Modal>
            </>
        )
    }
}

export default DwView
